export enum RoleRank {
  Primary = 'primary',
  Secondary = 'secondary',
}

export interface OptionType {
  label: string
  description: string
  value: string
  slug?: string
  roleRank?: RoleRank
}
